export default __webpack_public_path__ + "static/media/bank-closed.fd2a172a.png";